// extracted by mini-css-extract-plugin
export default {"progressNumber":"progressBar_progressNumber__sixhC"};